const $doc = $(document)

$doc.on('click', '.js-btn-toggle', function (e) {
  e.preventDefault()

  const $this = $(this)
  const $target = $($this.data('js-target'))
  const className = $this.data('js-class')
  const activeClassName = $this.data('js-this-active-class')

  $target.toggleClass(className)

  if (activeClassName !== undefined) {
    $this.toggleClass(activeClassName)
  }
})
